function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 5.5a2.5 2.5 0 1 1-4.999.001A2.5 2.5 0 0 1 10.5 5.5zM3 11.75c0-1.662 3.331-2.5 5-2.5s5 .838 5 2.5v.625a.627.627 0 0 1-.625.625h-8.75A.627.627 0 0 1 3 12.375v-.625z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user.908f766b.svg";
export { SvgComponent as ReactComponent };